/* * 收藏夹 * 作者：杨晓霞 */
<template>
  <ScrollView
    class="wrapper"
    :probeType="2"
    :pulldown="pulldown"
    :listenScroll="true"
    pullup="pullup"
    @scrollToEnd="scrollToEnd"
    ref="favoriteWrap"
    :data="favoriteActivityList"
    style="overflow-y:hidden"
  >
    <div class="about">
      <ul ref="favoriteUl">
        <li class="list-item" v-for="(item, index) in favoriteActivityList" data-type="0" :key="index">
          <div @touchstart.capture="touchStart" @touchend.capture="touchEnd" @click="jumpToOver">
            <div @click="flag(item.activityId, item.deleteFlag)" class="J_ping list-box" report-eventid="MInterestFree_CollectionContent" :report-eventparam="item.activityId">
              <div class="favortieBigImgWrap">
                <img class="favorite-list-img" :src="item.imageUrl" alt="" />
              </div>
              <div class="list-content jrm-border-1px jrm-border-bottom">
                <div class="list-descript-wrap">
                  <div class="titleStyle1">
                    <p class="HiddenExtra">{{ item.title }}</p>
                  </div>
                  <div class="tips-wrap-activity">
                    <p class="money-icon-img">
                      <img v-lazy="item.avatar" alt=" " class="money-icon-imgBase" />
                    </p>
                    <p class="active-money instalment-zoom ">{{ item.author }}</p>
                    <p class="active-money">{{ item.releaseTime }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="btnWrap ">
            <div v-if="!item.deleteFlag" class="btnList shareBtn" @click="shareItem(item)" :data-index="index">分享</div>
            <div v-if="item.deleteFlag" class="btnList" :data-index="index"></div>
            <div class="btnList deleteBtn " @click="deleteItem(item, index)" :data-index="index">删除</div>
          </div>
        </li>
      </ul>
      <div v-if="hasMore">
        <NoMoreData :hasMoreData="hasMoreData"></NoMoreData>
      </div>
      <NullDataShow :isShowNullImage="isShowNullImage" />
    </div>
  </ScrollView>
</template>

<script>
import ScrollView from '@/components/ScrollView.vue';
import { shareOpen, shareInit, HideShare } from '@/util/share';
import request from '@/util/request';
import NoMoreData from '@/buscomponents/NoMoreData.vue';
import NullDataShow from '@/buscomponents/NullDataShow.vue';
import { genLinkBySSR } from '@/util/common';
import { messages } from '@/config';

export default {
  name: 'favorite',
  components: {
    ScrollView,
    NoMoreData,
    NullDataShow
  },
  data() {
    return {
      hasMore: false,
      pulldown: false,
      pullup: true,
      favoriteActivityList: [],
      startX: 0,
      endX: 0,
      pageNum: 1,
      isFinalPage: false,
      hasMoreData: false,
      isShowNullImage: false
    };
  },
  computed: {
    wHeight: () => {
      return document.body.offsetHeight;
    },
    scrHeight: () => {
      return document.body.scrollHeight;
    }
  },
  created() {
    // 初始化时就开始赋值分享参数
    this.$loading.show();
    this.initArgs();
    this.getList();
  },
  methods: {
    flag(activityId, delFlag) {
      !delFlag && this.$router.push({ path: 'activity', query: { activityId: activityId } });
      delFlag && this.$toast.show({ text: '活动已失效' });
    },
    //获取列表
    getList() {
      request.getFavoriteActivityList({
        data: {
          pageNum: this.pageNum
        },
        success: data => {
          this.$loading.hide();
          if (data && data.favoriteActivityList && data.favoriteActivityList.length) {
            this.favoriteActivityList = this.favoriteActivityList.concat(data.favoriteActivityList);
          }
          if (this.favoriteActivityList && !this.favoriteActivityList.length) {
            this.isShowNullImage = true;
          }
          this.isFinalPage = data.isFinalPage;
          if (this.isFinalPage) {
            this.hasMoreData = false;
          } else {
            this.hasMoreData = true;
          }
          this.offsetHtg();
        },
        afterError: () => {
          this.$loading.hide();
        }
      });
    },
    //删除活动或商品
    delete(item, index) {
      //删除活动
      request.addOrDelActivity({
        data: {
          activityId: item.activityId
        },
        success: data => {
          if (data && data.isOperateSuccess) {
            this.favoriteActivityList.splice(index, 1);
            this.$toast.show({ text: '删除成功' });
            this.$nextTick(() => {
              this.$refs.favoriteWrap.refresh();
              if (this.favoriteActivityList && !this.favoriteActivityList.length) {
                this.isShowNullImage = true;
              } else {
                this.isShowNullImage = false;
              }
            });
          } else {
            this.$toast.show({ text: '删除失败' });
          }
        }
      });
    },
    //滑动开始
    touchStart(e) {
      // 记录初始位置
      this.startX = e.touches[0].clientX;
    },
    //滑动结束
    touchEnd(e) {
      // 当前滑动的父级元素
      let parentElement = e.currentTarget.parentElement;
      // 记录结束位置
      this.endX = e.changedTouches[0].clientX;
      // 左滑
      if (parentElement.dataset.type == 0 && this.startX - this.endX > 30) {
        this.restSlide();
        parentElement.dataset.type = 1;
      }
      // 右滑
      if (parentElement.dataset.type == 1 && this.startX - this.endX < -30) {
        this.restSlide();
        parentElement.dataset.type = 0;
      }
      this.startX = 0;
      this.endX = 0;
    },
    //判断当前是否有滑块处于滑动状态
    checkSlide() {
      let listItems = document.querySelectorAll('.list-item');
      for (let i = 0; i < listItems.length; i++) {
        if (listItems[i].dataset.type == 1) {
          return true;
        }
      }
      return false;
    },
    //复位滑动状态,页面中只可以有一个元素处于滑动状态,有一个在滑动的时候另外一个就要恢复到原始位置
    restSlide() {
      let listItems = document.querySelectorAll('.list-item');
      // 复位
      for (let i = 0; i < listItems.length; i++) {
        listItems[i].dataset.type = 0;
      }
    },
    //跳转,跳转时先判断当前是否有处于滑动状态的滑块，有的话要复位
    jumpToOver() {
      if (this.checkSlide()) {
        this.restSlide();
      } else {
        console.log('You click the slide!');
      }
    },
    //删除
    deleteItem(item, index) {
      // let index = index;
      this.restSlide();
      this.delete(item, index); //删除指定的元素
      // this.favoriteGoodsList.splice(index, 1);
      // this.getList(index);
    },
    //分享
    shareItem(item) {
      let shareData = item.shareInfo;
      let href = '';
      let activityId = item.activityId;
      // console.log(this.$route.params)
      href = genLinkBySSR('activity', `activityId=${activityId}`);
      shareOpen({ shareURL: href, shareImgSrc: shareData.shareImageUrl, shareTitle: shareData.shareTitle, shareDesc: shareData.shareSubTitle });
    },
    //滚动到底部触发事件
    scrollToEnd() {
      if (!this.isFinalPage) {
        this.pageNum++;
        this.getList();
      }
    },
    offsetHtg() {
      setTimeout(() => {
        let $ulHtg = $(this.$refs.favoriteUl)[0].clientHeight;
        let winHtg = document.body.offsetHeight;
        this.hasMore = $ulHtg > winHtg ? true : false;
      }, 300);
    },
    initArgs() {
      let href = '';
      href = genLinkBySSR('activity');
      let defaultOption = {
        shareURL: href,
        shareImgSrc: 'https://img12.360buyimg.com/jrpmobile/jfs/t28069/118/1531685442/19730/8e0317ae/5ce36be5Nf2ce9f2c.png',
        shareTitle: messages.shareTitle,
        shareDesc: messages.shareDesc,
        shareChannels: ['0', '1', '3']
      };
      shareInit(defaultOption);
    }
  },
  mounted() {
    HideShare({ title: '收藏夹', moreItem: true, hideTools: false, backColor: '#ffffff', textColor: 2 });
  },
  destroyed() {
    this.ListTimeOut && clearTimeout(this.ListTimeOut);
    this.$refs = null;
    this._self = null;
  }
};
</script>

<style lang="scss" scoped>
@import './../scss/mixin.scss';

.wrapper {
  position: absolute;
  // top: $rem100;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.about {
  display: flex;
  flex-direction: column;
  padding-bottom: $rem100;
  // height: 100%;
}
.active {
  border-bottom-width: 3px;
  border-bottom-color: #c29451;
  border-style: solid;
  color: #c29451 !important;
}
.list_wrap li {
  height: $rem230;
  margin-bottom: $rem10;
}

// 左侧滑动删除按钮
.page-title {
  text-align: center;
  font-size: 17px;
  padding: 10px 15px;
  position: relative;
}
.page-title:after {
  content: ' ';
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
  height: 1px;
  border-bottom: 1px solid #ccc;
  color: #ccc;
  -webkit-transform-origin: 0 100%;
  transform-origin: 0 100%;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
  z-index: 2;
}
.list-item {
  position: relative;
  height: $rem230;
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
}
.list-item[data-type='0'] {
  transform: translate3d(0, 0, 0);
}
.list-item[data-type='1'] {
  transform: translate3d(-$rem240, 0, 0);
}

.list-box {
  display: flex;
  align-items: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  justify-content: flex-end;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  font-size: 0;
}
.favortieBigImgWrap {
  width: $rem247;
  height: $rem142;
  margin-right: $rem25;
  margin-left: $rem21;
  overflow: hidden;
}
.favorite-list-img {
  display: block;
  width: 100%;
  height: auto;
}
.list-item .list-content {
  height: $rem230;
  position: relative;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.list-descript-wrap {
  height: $rem142;
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding-right: $rem25;
}
//未失效或着未售完的样式
.titleStyle1 {
  font-family: PingFangSC-Regular;
  font-size: $rem28;
  color: #333333;
  letter-spacing: 0;
  flex: 1;
  line-height: $rem46 !important;
  position: relative;
}
//失效或着售完的样式
.titleStyle2 {
  font-family: PingFangSC-Regular;
  font-size: $rem28;
  color: #999999;
  letter-spacing: 0;
  flex: 1;
  line-height: $rem48 !important;
  position: relative;
}
//如果售完了分期的信息隐藏
.hideStyle {
  display: none !important;
}
.showStyle {
  display: block !important;
}
.label-wrap {
  padding: $rem2 $rem9;
  background: #999;
  font-family: PingFangSC-Regular;
  font-size: $rem22;
  color: #ffffff;
  letter-spacing: 0;
  margin-right: $rem10;
}
.tips-wrap-good {
  display: flex;
  font-size: 12px;
  align-items: flex-end;
  padding-top: $rem24;
}
.tips-wrap-activity {
  display: flex;
  font-size: 12px;
  align-items: center;
}
.list-item .time {
  display: block;
  font-size: 12px;
  position: absolute;
  right: 0;
  top: 0.1rem;
  color: #666;
}
.list-item .btnWrap {
  width: $rem240;
  height: $rem230;
  font-size: 17px;
  color: #fff;
  position: absolute;
  top: 0;
  right: -$rem240;
  display: flex;
}
.btnList {
  flex: 1;
  text-align: center;
  line-height: $rem230;
}
.shareBtn {
  background: #c29451;
  border-radius: 1px;
}
.deleteBtn {
  background: #fc3337;
  border-radius: 1px;
}

.money-icon1 {
  color: #c29451;
  font-size: $rem24;
  margin-right: $rem10;
}
.money-icon2 {
  font-size: $rem24;
  color: #999999;
}

.money-icon-img {
  width: $rem40;
  height: $rem40;
  border-radius: $rem40;
  margin-right: $rem10;
  overflow: hidden;
}
.money-icon-imgBase {
  // width: $rem40;
  // height: $rem40;
  width: 100%;
  height: auto;
}
.instalment-amount {
  font-family: Helvetica-Bold;
  font-size: $rem32;
  color: #c29451;
  letter-spacing: 0;
  line-height: $rem29;
  // margin-right: $rem4;
}
.chenghao {
  font-family: Helvetica;
  font-size: $rem24;
  color: #c29451;
  letter-spacing: 0;
  margin-left: $rem8;
  margin-right: $rem2;
}
.instalmentStyle {
  font-family: Helvetica;
  font-size: $rem24;
  color: #c29451;
  letter-spacing: 0;
}
.instalment-zoom {
  margin-right: $rem25;
}
.amount-wrap {
  font-family: Helvetica;
  font-size: $rem24;
  color: #999999;
  letter-spacing: 0;
  display: flex;
  justify-content: center;
  align-items: flex-end;
}

.active-money {
  font-family: PingFangSC-Regular;
  font-size: $rem24;
  color: #999999;
  letter-spacing: 0;
}

.hasLabelColr {
  color: #999999 !important;
}
.noMoreStyle {
  text-align: center;
  padding-bottom: $rem80;
  padding-top: $rem80;
  font-family: PingFangSC-Regular;
  font-size: $rem24;
  color: #c2c2c2;
  letter-spacing: 0;
  display: none;
}
.HiddenExtra {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
